import { useMemo } from "react";

interface CanvasDimensions {
  rectWidth: number;
  rectHeight: number;
  rectX: number;
  rectY: number;
}

/**
 * Custom hook to calculate canvas dimensions
 * Centers the image within the available container space
 */
export const useCanvasDimensions = (
  containerWidth: number,
  containerHeight: number,
  aspectRatio: number,
  padding: number = 50,
): CanvasDimensions => {
  return useMemo(() => {
    let rectWidth = containerWidth - padding;
    let rectHeight = rectWidth / aspectRatio;

    // If height exceeds container, scale based on height instead
    if (rectHeight > containerHeight - padding) {
      rectHeight = containerHeight - padding;
      rectWidth = rectHeight * aspectRatio;
    }

    const rectX = (containerWidth - rectWidth) / 2;
    const rectY = (containerHeight - rectHeight) / 2;

    return {
      rectWidth,
      rectHeight,
      rectX,
      rectY,
    };
  }, [containerWidth, containerHeight, aspectRatio, padding]);
};
